/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportCrashRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {ReportCrashResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const reportCrash = (request:ReportCrashRequest, options?: CashRequestOptions) => post<ReportCrashRequest, ReportCrashResponse>("/2.0/cash/report-crash", request, {...options, rejectOnError: true })